import React from 'react';
import { useLocation } from '@thd-olt-component-react/router';
import { Row } from '@thd-olt-component-react/grid';
import { Metadata } from '@thd-olt-component-react/metadata';
import { GiftCardsList } from '@thd-olt-component-react/gift-cards-list';
import { Typography } from '@one-thd/sui-atomic-components';
import { GiftCardMaintenanceAlert, useDisabledGiftCardFlow } from '@thd-olt-component-react/gift-cards-information';
import { GiftCardsCarousel } from '@thd-olt-component-react/gift-cards-carousel'
import { FEATURE_SWITCH_NAMES, staticPageUrls } from '../utils/consts';
import Breadcrumbs from '../components/breadcrumbs/Breadcrumbs';

export const ThirdPartyList = () => {
  const { pathname } = useLocation();

  const metaData = {
    alternateUrlEn: 'https://www.homedepot.com/gift-cards/specialty-cards',
    alternateUrlEnCa: 'https://www.homedepot.ca/en/home/gift-cards.html',
    alternateUrlFrCa: 'https://www.homedepot.ca/fr/accueil/cartes-cadeaux.html',
    canonicalURL: pathname,
    description: 'Shop for the Home Depot gift card and make shopping for home improvement easier than ever. '
    + 'Free delivery on traditional gift cards, personalized e-gift cards to suit any occasion. '
    + 'Get discounts on bulk orders today!',
    facebookAdmins: '100005416960152',
    siteName: 'The Home Depot',
    title: 'Buy Gift Card - Specialty Cards',
    type: 'Content',
  }

  const { isFlowDisabled } = useDisabledGiftCardFlow(FEATURE_SWITCH_NAMES.DISABLE_GIFT_CARD_PURCHASE);

  return (
    <>
      <Row className="sui-max-w-screen-2xl sui-m-auto" data-testid="specialty-cards-container">
        <Metadata data={metaData} />
        <div className="sui-mt-6 sui-mb-2 sui-ml-3" data-testid="breadcrumbs-specialty-cards">
          <Breadcrumbs
            startFromHome
            breadcrumbs={
              [
                staticPageUrls.landing,
                {
                  ...staticPageUrls.thirdParty
                }
              ]
            }
          />
        </div>
        <>
          <div className="sui-w-full sui-p-2 sui-mb-8">
            <Typography variant="h1" weight="display">
              {staticPageUrls.thirdParty.name.toUpperCase()}
            </Typography>
          </div>
          {isFlowDisabled ? <GiftCardMaintenanceAlert /> : (
            <>
              <GiftCardsList jsonType={2} />
              <div className="sui-w-full sui-p-2" data-testid="hd-gift-cards-carousel">
                <GiftCardsCarousel jsonType={1} />
              </div>
            </>
          )}
        </>
      </Row>
    </>
  );
};

ThirdPartyList.displayName = 'ThirdPartyGiftCardsPage';
